import React, { FC, ReactNode } from "react";

import classNames from "classnames";

import styles from "./DetailCell.module.scss";

interface CellProps {
  title: string;
  value: ReactNode;
  titleClassName?: string;
  labelClassName?: string;
}

export const DetailCell: FC<CellProps> = ({ title, value, titleClassName, labelClassName }) => {
  return (
    <>
      <span
        className={classNames(
          { [styles["detail_title"]]: !titleClassName },
          { [titleClassName!]: titleClassName },
          "b5 medium",
        )}
      >
        {title}
      </span>
      <span
        className={classNames(
          { [styles["detail_value"]]: !labelClassName },
          { [labelClassName!]: labelClassName },
          "b3",
        )}
      >
        {value}
      </span>
    </>
  );
};
